import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import Header from './Header';
import Footer from './Footer';
import { Button, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation, Link } from 'react-router-dom';
import RoomImageSlider from './RoomImageSlider';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const Viewroomdetails = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const checkInDate = searchParams.get('checkInDate');
  const checkOutDate = searchParams.get('checkOutDate');
  const totalrooms = searchParams.get('totalrooms');
  const totalguest = searchParams.get('totalguest');
  const id = searchParams.get('id');

  const [roomDetails, setRoomDetails] = useState(null);
  const [relatedRooms, setRelatedRooms] = useState([]);
  const [error, setError] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [checkInDateState, setCheckInDate] = useState(
    checkInDate ? new Date(moment(checkInDate, 'DD-MM-YYYY')) : null
  );
  const [checkOutDateState, setCheckOutDate] = useState(
    checkOutDate ? new Date(moment(checkOutDate, 'DD-MM-YYYY')) : null
  );
  const [rooms, setRooms] = useState([
    { id: 1, count: parseInt(totalguest) || 1 }
  ]);

  const incrementCount = (roomId) => {
    setRooms(rooms.map(room => 
      room.id === roomId ? { ...room, count: room.count + 1 } : room
    ));
  };

  const decrementCount = (roomId) => {
    setRooms(rooms.map(room => 
      room.id === roomId && room.count > 1 ? { ...room, count: room.count - 1 } : room
    ));
  };

  const addRoom = () => {
    const newId = Math.max(...rooms.map(r => r.id)) + 1;
    setRooms([...rooms, { id: newId, count: 1 }]);
  };

  const deleteRoom = () => {
    if (rooms.length > 1) {
      setRooms(rooms.slice(0, -1));
    }
  };

  useEffect(() => {
    if (checkInDate && checkOutDate && id) {
      const formattedCheckInDate = moment(checkInDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
      const formattedCheckOutDate = moment(checkOutDate, 'DD-MM-YYYY').format('YYYY-MM-DD');

      const fetchData = async () => {
        try {
          const response = await axios.get(`https://api.abhyaranyan.com/api/Abhyaranyan/RoomDetailbyid`, {
            params: {
              checkInDate: formattedCheckInDate,
              checkOutDate: formattedCheckOutDate,
              totalrooms,
              totalguest,
              id,
            },
          });

          setRoomDetails(response.data.data);

          if (response.data.data.roomsList && response.data.data.roomsList.length > 0) {
            const relatedRoomsList = response.data.data.roomsList
              .filter(room => room.id !== parseInt(id))
              .slice(0, 3);
            setRelatedRooms(relatedRoomsList);
          }
        } catch (err) {
          console.error(err);
          setError('Failed to fetch room details.');
        }
      };

      fetchData();
    }
  }, [checkInDate, checkOutDate, totalrooms, totalguest, id]);
  // Load Razorpay script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const handlePayment = async () => {
    const firstName = document.getElementById('firstName').value;
    const lastName = document.getElementById('lastName').value;
    const email = document.getElementById('emailHelp').value;
    const contact = document.getElementById('mobile-no').value;
    const gender = document.getElementById('Gender').value;
    const address = document.getElementById('Address').value;

    if (!firstName || !lastName || !email || !contact || !gender || !address) {
      alert('Please fill all guest details before proceeding to payment.');
      return;
    }
    try {
      const response = await axios.post(`https://api.abhyaranyan.com/api/Abhyaranyan/RoomDetailbyid?id=${id}`, {
        roomid: id,
        firstName,
        lastName,
        gender,
        phone: contact,
        emailAddress: email,
        address,
        amount: roomDetails.amount,
        checkInDate: roomDetails.checkInDate,
        checkOutDate: roomDetails.checkOutDate,
        totalPerson: totalguest,
        numberofRooms: totalrooms,
        paymentMode_Id: 0,
        razorpayKey: 'rzp_test_BXjJAJuQSCxc3X',
        paymentId: 'temp_id',
        isPaymentStatus: true,
        order_Id: 'temp_order_id',
      });

      if (response.data.succeeded) {
        const { amount } = response.data.data;
        const options = {
          key: 'rzp_test_BXjJAJuQSCxc3X',
          amount: amount * 100,
          currency: 'INR',
          name: 'Abhyaranyan',
          description: 'Room Booking',
          handler: function (paymentResponse) {
            alert('Payment successful! Payment ID: ' + paymentResponse.razorpay_payment_id);
            alert('Booking Confirmed successfully!');
          },
          prefill: {
            name: `${firstName} ${lastName}`,
            email,
            contact,
          },
          notes: {
            address,
          },
          theme: {
            color: '#3399cc',
          },
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.open();
      } else {
        alert('Booking failed. Please try again.');
      }
    } catch (error) {
      console.error('Booking failed:', error);
      alert('Booking failed. Please try again.');
    }
  };

  if (error) {
    return (
      <div className="container mt-5 text-center">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  if (!roomDetails) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="container my-5">
        <div className="row">
          <div className="col-lg-8">            <div className="top">
              <h2 className="hotel-title">Sea View Hotel</h2>
              <div className="rating">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="far fa-star"></i>
              </div>
            </div>
            <img
              src={`https://admin.abhyaranyan.com/RoomsUploadimage/${roomDetails.roomImage}`}
              alt={roomDetails.roomType}
              style={{ width: '100%', height: '400px', objectFit: 'cover' }}
              className="mb-4"
            />
            <RoomImageSlider imageJson={roomDetails.imageJson} />
          </div>

        <div className="col-lg-4">
  <Card className="p-4">
    <h4>Sea View Hotel</h4>
    <div className="search-body mb-3">
      <h6>Check In</h6>
      <DatePicker
        selected={checkInDateState}
        onChange={(date) => setCheckInDate(date)}
        placeholderText="Select Check-in Date"
        className="form-control"
        dateFormat="dd/MM/yyyy"
      />
    </div>
    <div className="search-body mb-3">
      <h6>Check Out</h6>
      <DatePicker
        selected={checkOutDateState}
        onChange={(date) => setCheckOutDate(date)}
        placeholderText="Select Check-out Date"
        className="form-control"
        dateFormat="dd/MM/yyyy"
        minDate={checkInDateState ? new Date(checkInDateState.getTime() + 86400000) : null}
      />
    </div>
    <div 
      className="search-body mb-3" 
      onClick={() => setPopupVisible(true)} 
      style={{ cursor: "pointer" }}
    >
      <h6>Rooms & Guests</h6>
      <div className="form-control">
        {`${rooms.length} Room${rooms.length > 1 ? 's' : ''}, ${rooms.reduce((total, room) => total + room.count, 0)} Guest${rooms.reduce((total, room) => total + room.count, 0) > 1 ? 's' : ''}`}
      </div>
    </div>
    
    {popupVisible && (
      <div className="popup" style={{ position: 'relative' }}>
        <div className="popup-content">
          <div className="room-control">
            <h6>Rooms & Guests</h6>
          </div>
          <hr />
          {rooms.map((room, index) => (
            <div key={room.id} className="room-control">
              <span>Room {index + 1}</span>
              <div>
                <button className="btn btn-sm btn-outline-secondary" onClick={() => decrementCount(room.id)}>-</button>
                <span className="mx-2">{room.count}</span>
                <button className="btn btn-sm btn-outline-secondary" onClick={() => incrementCount(room.id)}>+</button>
              </div>
            </div>
          ))}
          <hr />
          <div className="d-flex justify-content-between">
            <Button variant="link" className="text-danger" onClick={deleteRoom}>Delete Room</Button>
            <Button variant="link" className="text-primary" onClick={addRoom}>Add Room</Button>
          </div>
        </div>
      </div>
    )}
    
    <Button variant="primary" className="w-100" onClick={handlePayment}>
      Book Now
    </Button>
  </Card>
</div>
        </div>

           <section className="single-section bg-inner small-section">
  <div className="container">
    <div className="row">
      <div className="col-12 small-section pb-0">
        <div className="description-section tab-section">
          {/* Tab Navigation */}
          <div className="menu-top menu-up">
            <ul className="nav nav-tabs" id="top-tab" role="tablist">
              <li className="nav-item">
                <a 
                  className="nav-link active"
                  data-bs-toggle="tab"
                  href="#rooms"
                  role="tab"
                >
                  Room
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#about"
                  role="tab"
                >
                  About
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#facility"
                  role="tab"
                >
                  Facility
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#location"
                  role="tab"
                >
                  Location
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#reviews"
                  role="tab"
                >
                  Reviews
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className="nav-link"
                  data-bs-toggle="tab"
                  href="#policies"
                  role="tab"
                >
                  Policies
                </a>
              </li>
            </ul>
          </div>

          {/* Tab Content */}
          <div className="description-details tab-content" id="top-tabContent">
            {/* Rooms Tab */}
            <div className="tab-pane fade show active" id="rooms" role="tabpanel">
              <table className="rooms-box">
                <tbody>
                  <tr>
                    <td>
                      <h6 className="room-title">Deluxe Room</h6>
                      <div className="room-image">
                        <img 
                          src="https://admin.abhyaranyan.com/RoomsUploadimage/1e5d0177-c351-4efa-bdf6-26b2f951c45f20240807114159389.png"
                          className="img-fluid blur-up lazyload" 
                          alt="Deluxe Room" 
                        />
                      </div>
                    </td>
                    <td>
                      <div className="room-detail">
                        <div className="row">
                          <div className="col-6 p-0">
                            <h6>Amenities</h6>
                            <div className="facility-detail">
                              <ul>
                                <li>
                                  <img src="../assets/images/icon/tour/bed.png" className="img-fluid blur-up lazyload" alt="Bed" />
                                  king/twin
                                </li>
                                <li>
                                  <img src="../assets/images/icon/hotel/shower.png" className="img-fluid blur-up lazyload" alt="Shower" />
                                  Shower
                                </li>
                                <li>
                                  <img src="../assets/images/icon/hotel/television.png" className="img-fluid blur-up lazyload" alt="TV" />
                                  LCD TV
                                </li>
                                <li>
                                  <img src="../assets/images/icon/hotel/couch.png" className="img-fluid blur-up lazyload" alt="Couch" />
                                  couch
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-6 p-0">
                            <h6>Inclusions</h6>
                            <div className="facility-detail">
                              <ul>
                                <li><i className="fas fa-check"></i> Wi-Fi</li>
                                <li><i className="fas fa-check"></i> Breakfast</li>
                                <li><i className="fas fa-check"></i> Non refundable</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="price-details">
                        <div>
                          <h6><del>₹3000</del></h6>
                          <h5>₹2500</h5>
                          <span>per night</span>
                          <button 
                            onClick={() => handlePayment()} 
                            className="btn btn-rounded btn-sm color1"
                          >
                            Book Now
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 className="room-title">Suite Room</h6>
                      <div className="room-image">
                        <img 
                          src="https://admin.abhyaranyan.com/RoomsUploadimage/8a6d98b4-10a4-43ce-beb3-4a7c507cb0a420240807114212727.png"
                          className="img-fluid blur-up lazyload" 
                          alt="Suite Room" 
                        />
                      </div>
                    </td>
                    <td>
                      <div className="room-detail">
                        <div className="row">
                          <div className="col-6 p-0">
                            <h6>Amenities</h6>
                            <div className="facility-detail">
                              <ul>
                                <li>
                                  <img src="../assets/images/icon/tour/bed.png" className="img-fluid blur-up lazyload" alt="Bed" />
                                  king/twin
                                </li>
                                <li>
                                  <img src="../assets/images/icon/hotel/pool.png" className="img-fluid blur-up lazyload" alt="Pool View" />
                                  Pool View
                                </li>
                                <li>
                                  <img src="../assets/images/icon/hotel/shower.png" className="img-fluid blur-up lazyload" alt="Shower" />
                                  Shower
                                </li>
                                <li>
                                  <img src="../assets/images/icon/hotel/television.png" className="img-fluid blur-up lazyload" alt="TV" />
                                  LCD TV
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-6 p-0">
                            <h6>Inclusions</h6>
                            <div className="facility-detail">
                              <ul>
                                <li><i className="fas fa-check"></i> Wi-Fi</li>
                                <li><i className="fas fa-check"></i> Breakfast</li>
                                <li><i className="fas fa-check"></i> Free cancellation</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="price-details">
                        <div>
                          <h6><del>₹3500</del></h6>
                          <h5>₹3000</h5>
                          <span>per night</span>
                          <button 
                            onClick={() => handlePayment()} 
                            className="btn btn-rounded btn-sm color1"
                          >
                            Book Now
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h6 className="room-title">Royal Room</h6>
                      <div className="room-image">
                        <img 
                          src="https://admin.abhyaranyan.com/RoomsUploadimage/951e1aa0-580f-41ec-83b5-f739ddeb99bb20240806173418618.jpg"
                          className="img-fluid blur-up lazyload" 
                          alt="Royal Room" 
                        />
                      </div>
                    </td>
                    <td>
                      <div className="room-detail">
                        <div className="row">
                          <div className="col-6 p-0">
                            <h6>Amenities</h6>
                            <div className="facility-detail">
                              <ul>
                                <li>
                                  <img src="../assets/images/icon/tour/bed.png" className="img-fluid blur-up lazyload" alt="Bed" />
                                  king/twin
                                </li>
                                <li>
                                  <img src="../assets/images/icon/hotel/pool.png" className="img-fluid blur-up lazyload" alt="Pool View" />
                                   Pool View
                                </li>
                                <li>
                                  <img src="../assets/images/icon/hotel/shower.png" className="img-fluid blur-up lazyload" alt="Shower" />
                                  Shower
                                </li>
                                <li>
                                  <img src="../assets/images/icon/hotel/television.png" className="img-fluid blur-up lazyload" alt="TV" />
                                   LCD TV
                                </li>
                                <li>
                                  <img src="../assets/images/icon/hotel/couch.png" className="img-fluid blur-up lazyload" alt="Couch" />
                                    couch
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-6 p-0">
                            <h6>Inclusions</h6>
                            <div className="facility-detail">
                              <ul>
                                <li><i className="fas fa-check"></i> Wi-Fi</li>
                                <li><i className="fas fa-check"></i> Breakfast</li>
                                <li><i className="fas fa-check"></i> Dinner & lunch</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="price-details">
                        <div>
                          <h6><del>₹5500</del></h6>
                          <h5>₹5000</h5>
                          <span>per night</span>
                          <button 
                            onClick={() => handlePayment()} 
                            className="btn btn-rounded btn-sm color1"
                          >
                            Book Now
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* About Tab */}
            <div className="tab-pane fade" id="about" role="tabpanel">
              <div className="card w-100 h-100">
                <div className="card-body p-8">
                  <div className="about-content"
                    dangerouslySetInnerHTML={{
                      __html: roomDetails?.aboutDescription || 'No description available'
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Facility Tab */}
            <div className="tab-pane fade" id="facility" role="tabpanel">
              <div className="card w-100 h-100">
                <div className="card-body p-8">
                  <div className="row g-4">
                    {/* Your existing facility items */}
                  </div>
                </div>
              </div>
            </div>

            {/* Location Tab */}
            <div className="tab-pane fade" id="location" role="tabpanel">
              <div className="card w-100 h-100">
                <div className="card-body p-8">
                  <div className="location-content mb-4">
                    <h4>Location Details</h4>
                    <p>{roomDetails?.location}</p>
                  </div>
                  <div className="google-map">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3443.7168542751736!2d77.57823599999999!3d30.296953!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390929e9bd20fbb3%3A0xaa8296cf4a257c29!2sAbhyaranyan!5e0!3m2!1sen!2sin!4v1653647282959!5m2!1sen!2sin"
                      style={{ border: 0, width: '100%', height: '400px' }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Location Map"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Reviews Tab */}
            <div className="tab-pane fade" id="reviews" role="tabpanel">
              <div className="card w-100 h-100">
                <div className="card-body p-8">
                  {/* Add your reviews content here */}
                </div>
              </div>
            </div>

            {/* Policies Tab */}
            <div className="tab-pane fade" id="policies" role="tabpanel">
              <div className="card w-100 h-100">
                <div className="card-body p-8">
                  {/* Add your policies content here */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
        {/* Related Hotels Section */}
        {relatedRooms.length > 0 && (
          <section className="section-b-space bg-white mt-5">
            <div className="container">
              <div className="title-1 title-5">
                <h2>Related Hotels</h2>
                <p>Explore other amazing options that might interest you</p>
              </div>
              <div className="row">
                {relatedRooms.map(room => (
                  <div className="col-lg-4 col-md-4 mb-4" key={room.id}>
                    <div className="hotel-box">
                      <div className="hotel-image">
                        <Link to={`/viewrooms?id=${room.id}&checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&totalrooms=${totalrooms}&totalguest=${totalguest}`}>
                          <img
                            src={`https://admin.abhyaranyan.com/RoomsUploadimage/${room.roomImage}`}
                            className="img-fluid"
                            alt={room.roomType}
                          />
                          {room.isSpecial && (
                            <div className="special-label">
                              <span>Special</span>
                            </div>
                          )}
                        </Link>
                      </div>
                      <div className="hotel-details">
                        <div className="hotel-info">
                          <div className="hotel-title-box">
                            <h5>
                              <Link to={`/viewrooms?id=${room.id}&checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&totalrooms=${totalrooms}&totalguest=${totalguest}`}>
                                {room.roomType}
                              </Link>
                            </h5>
                            <h6><i className="fas fa-map-marker-alt"></i> {room.location}</h6>
                          </div>
                        </div>
                        <div className="hotel-price">
                          {room.oldRent > room.rent && (
                            <del>₹{room.oldRent}</del>
                          )}
                          <h6>₹{room.rent}</h6>
                          {/* <Link
                            to={`/viewrooms?id=${room.id}&checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&totalrooms=${totalrooms}&totalguest=${totalguest}`}
                            className="btn btn-solid btn-sm"
                          >
                            Book Now
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Viewroomdetails;
